<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations sur l'activité</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.activityArea || originalMetadata?.activityArea"
      >
        <span class="card__label" i18n>Domaine d'activité principale</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.activityArea !== metadata.activityArea,
            }"
            >{{ metadata.activityArea }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.activityArea &&
              originalMetadata.activityArea !== metadata.activityArea
            "
            >{{ originalMetadata.activityArea }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.activityDescription || originalMetadata?.activityDescription
        "
      >
        <span class="card__label" i18n>Description de l'activité</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.activityDescription !==
                  metadata.activityDescription,
            }"
            >{{ metadata.activityDescription }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.activityDescription &&
              originalMetadata.activityDescription !==
                metadata.activityDescription
            "
            >{{ originalMetadata.activityDescription }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasLaborAgreement !== null &&
            metadata?.hasLaborAgreement !== undefined) ||
          (originalMetadata?.hasLaborAgreement !== null &&
            originalMetadata?.hasLaborAgreement !== undefined)
        "
      >
        <span class="card__label" i18n
          >A une convention collective de travail</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.hasLaborAgreement !==
                  metadata.hasLaborAgreement,
            }"
            >{{ getBooleanLabel(metadata.hasLaborAgreement) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.hasLaborAgreement !== null &&
              originalMetadata?.hasLaborAgreement !== undefined &&
              originalMetadata.hasLaborAgreement !== metadata.hasLaborAgreement
            "
            >{{ getBooleanLabel(originalMetadata.hasLaborAgreement) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.laborAgreement || originalMetadata?.laborAgreement"
      >
        <span class="card__label" i18n>Convention collective</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.laborAgreement !== metadata.laborAgreement,
            }"
            >{{ metadata.laborAgreement }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.laborAgreement &&
              originalMetadata.laborAgreement !== metadata.laborAgreement
            "
            >{{ originalMetadata.laborAgreement }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.isInternational !== null &&
            metadata?.isInternational !== undefined) ||
          (originalMetadata?.isInternational !== null &&
            originalMetadata?.isInternational !== undefined)
        "
      >
        <span class="card__label" i18n>Activité internationale</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.isInternational !== metadata.isInternational,
            }"
            >{{ getBooleanLabel(metadata.isInternational) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.isInternational !== null &&
              originalMetadata?.isInternational !== undefined &&
              originalMetadata.isInternational !== metadata.isInternational
            "
            >{{ getBooleanLabel(originalMetadata.isInternational) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.activityCountries?.length ||
          originalMetadata?.activityCountries?.length
        "
      >
        <span class="card__label" i18n>Pays d'activité</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getActivityCountriesText(originalMetadata.activityCountries) !==
                  getActivityCountriesText(metadata.activityCountries),
            }"
            >{{ getActivityCountriesText(metadata.activityCountries) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.activityCountries?.length &&
              getActivityCountriesText(originalMetadata.activityCountries) !==
                getActivityCountriesText(metadata.activityCountries)
            "
            >{{
              getActivityCountriesText(originalMetadata.activityCountries)
            }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasSubcontractors !== null &&
            metadata?.hasSubcontractors !== undefined) ||
          (originalMetadata?.hasSubcontractors !== null &&
            originalMetadata?.hasSubcontractors !== undefined)
        "
      >
        <span class="card__label" i18n>Emploie des sous-traitants</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.hasSubcontractors !==
                  metadata.hasSubcontractors,
            }"
            >{{ getBooleanLabel(metadata.hasSubcontractors) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.hasSubcontractors !== null &&
              originalMetadata?.hasSubcontractors !== undefined &&
              originalMetadata.hasSubcontractors !== metadata.hasSubcontractors
            "
            >{{ getBooleanLabel(originalMetadata.hasSubcontractors) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.collaboratorsCount != undefined ||
          originalMetadata?.collaboratorsCount != undefined
        "
      >
        <span class="card__label" i18n>Nombre de collaborateurs</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.collaboratorsCount !==
                  metadata?.collaboratorsCount,
            }"
            >{{ metadata?.collaboratorsCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.collaboratorsCount != undefined &&
              originalMetadata?.collaboratorsCount !==
                metadata?.collaboratorsCount
            "
            >{{ originalMetadata.collaboratorsCount }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.yearlyAnnualRevenue != undefined ||
          originalMetadata?.yearlyAnnualRevenue != undefined
        "
      >
        <span class="card__label" i18n>Chiffre d'affaires annuel brut</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.yearlyAnnualRevenue !==
                  metadata?.yearlyAnnualRevenue,
            }"
            >{{ metadata?.yearlyAnnualRevenue }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.yearlyAnnualRevenue != undefined &&
              originalMetadata?.yearlyAnnualRevenue !==
                metadata?.yearlyAnnualRevenue
            "
            >{{ originalMetadata.yearlyAnnualRevenue }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.yearlySalaries != undefined ||
          originalMetadata?.yearlySalaries != undefined
        "
      >
        <span class="card__label" i18n>Masse salariale annuelle</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.yearlySalaries !== metadata?.yearlySalaries,
            }"
            >{{ metadata?.yearlySalaries }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.yearlySalaries != undefined &&
              originalMetadata?.yearlySalaries !== metadata?.yearlySalaries
            "
            >{{ originalMetadata.yearlySalaries }} CHF</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
